import type { SgidMap } from "@circle-react-shared/AiConversation/message/tiptapToPlainText";
import type { JSONContent } from "@tiptap/core";

const nodeToAnnotatedText = (node: JSONContent, sgidMap: SgidMap): string => {
  switch (node.type) {
    case "text":
      return node.text ?? "";
    case "mention": {
      const obj = sgidMap[node.attrs?.sgid];
      if (!obj) return "";
      return `@${obj.name} (type: ${obj.type}, id: ${obj.id})`;
    }
    case "entity": {
      const obj = sgidMap[node.attrs?.sgid];
      if (!obj) return "";
      return `#${obj.name} (type: ${obj.type}, id: ${obj.id})`;
    }
    case "hardBreak":
      return "\n";
    case "paragraph":
    default:
      return (node.content ?? [])
        .map(n => nodeToAnnotatedText(n, sgidMap))
        .join("");
  }
};

export const tiptapToAnnotatedText = (
  doc: JSONContent,
  sgidMap: SgidMap,
): string => {
  if (!doc?.content) return "";
  return doc.content.map(n => nodeToAnnotatedText(n, sgidMap)).join("\n");
};

export const hasMeaningfulContent = (doc: JSONContent): boolean => {
  if (!doc?.content) return false;

  const walk = (node: JSONContent): boolean => {
    if (node.type === "mention" || node.type === "entity") return true;
    if (node.type === "text" && (node.text ?? "").trim().length > 0)
      return true;
    return (node.content ?? []).some(walk);
  };

  return walk(doc);
};
